import React, { useState } from 'react';
import {
  Box,
  Button,
  Typography,
  IconButton,
  Stack,
  Avatar,
  Paper,
  Divider,
  Chip,
  LinearProgress,
  Alert
} from '@mui/material';
import { CloudUpload, Delete, CheckCircle, ArrowBack } from '@mui/icons-material';
import { vendorApi } from '../../../api/api';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import GradientButton from '../../common/GradiantButton';
import SecondaryButton from '../../common/SecondaryButton';
import { useNavigate } from "react-router-dom";

const YourApartmentPlotAddImages = () => {
  const location = useLocation();
const aprtmentData = location.state?.property || {};
  const theme = useSelector((data) => data.themeValue.colors);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadStatus, setUploadStatus] = useState(null); 

  const navigate = useNavigate();
  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    setSelectedFiles((prev) => [...prev, ...files]);
    setUploadStatus(null);
  };

  console.log(aprtmentData);
  
  const handleRemoveImage = (index) => {
    setSelectedFiles((prev) => prev.filter((_, i) => i !== index));
  };

const handleUpload = async () => {
  if (!aprtmentData.id || !aprtmentData.type || selectedFiles.length === 0) 
 {
    setUploadStatus('error');
    return;
  }

  const formData = new FormData();
  selectedFiles.forEach((file) => {
    formData.append("Images[]", file);
  });

  formData.append("id", aprtmentData.id);
  formData.append("type", 3);

  try {
    setUploadStatus('uploading');


    const response = await vendorApi.addImagesById(formData); 
    if (response.status === 200) {
    setUploadStatus("success");
    setSelectedFiles([]);

    // wait 2 seconds then go back
    setTimeout(() => {
      navigate(-1); // go back to previous page
    }, 2000);

  } else {
    setUploadStatus("error");
  }
}catch (error) {
    console.error("Upload error:", error);
    setUploadStatus('error');
  }
};


  return (
    <Paper  sx={{ 
      p: 4,
      borderRadius: 2,
      width:"100%",
      marginTop:"30px",
    display:"flex",
      justifyContent:"center",
     textAlign:"center",
      alignItems:"center",
      alignContent:"center",
      backgroundColor:theme.background
    }}>
     <Box sx={{width:"50%", }}>
        <Box display="flex" alignItems="center" gap={1} mb={3}>
    <IconButton onClick={() => navigate(-1)}>
        <ArrowBack sx={{ color: theme.text }} />
    </IconButton>
    <Typography variant="h5" sx={{ 
        fontWeight: 600,
        color: theme.text,
        display: 'flex',
        alignItems: 'center',
        gap: 1
    }}>
        <CloudUpload fontSize="large" sx={{ color: theme.normal_icon }} />
        Upload Apartment Images
    </Typography>
</Box>

      <Divider sx={{ mb: 3,backgroundColor: theme.secondary_text_color}} />

      {/* Upload Area */}
      <Box sx={{ 
        border: '2px dashed',
        borderColor: 'primary.light',
        borderRadius: 2,
        p: 4,
        textAlign: 'center',
        backgroundColor: 'rgba(25, 118, 210, 0.04)',
        mb: 3,
        '&:hover': {
          backgroundColor: 'rgba(25, 118, 210, 0.08)'
        }
      }}>
        <input
          type="file"
          accept="image/*"
          multiple
          onChange={handleFileChange}
          style={{ display: 'none' }}
          id="villa-image-upload"
        />

        <label htmlFor="villa-image-upload">
          <Button 
            variant="outlined" 
            color="primary" 
            component="span"
            startIcon={<CloudUpload />}
            sx={{
              px: 4,
              py: 1.5,
              borderRadius: 2,
              textTransform: 'none',
              fontWeight: 600
            }}
          >
            Browse Files
          </Button>
        </label>

        <Typography variant="body2" sx={{ mt: 2, color: theme.text }}>
          {selectedFiles.length > 0 
            ? `${selectedFiles.length} file${selectedFiles.length > 1 ? 's' : ''} selected`
            : 'Drag & drop images here or click to browse'}
        </Typography>
      </Box>

      {/* Status Messages */}
      {uploadStatus === 'error' && (
        <Alert severity="error" sx={{ mb: 3 }}>
          Please select images and ensure Apartment data exists.
        </Alert>
      )}

      {uploadStatus === 'uploading' && (
        <Box sx={{ mb: 3 }}>
          <LinearProgress 
            variant="determinate" 
            value={uploadProgress} 
            sx={{ height: 8, borderRadius: 4 }}
          />
          <Typography variant="caption" sx={{ mt: 1, display: 'block' }}>
            Uploading: {uploadProgress}%
          </Typography>
        </Box>
      )}

      {uploadStatus === 'success' && (
        <Alert 
          severity="success" 
          sx={{ mb: 3 }}
          icon={<CheckCircle fontSize="inherit" />}
        >
          Images uploaded successfully!
        </Alert>
      )}

      {/* Selected Files Preview */}
      {selectedFiles.length > 0 && (
        <Box sx={{ mb: 3 }}>
          <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 500 }}>
            Selected Images ({selectedFiles.length})
          </Typography>
          
          <Stack spacing={2}>
            {selectedFiles.map((file, index) => (
              <Paper 
                key={index} 
                elevation={1}
                sx={{ 
                  p: 2,
                  borderRadius: 2,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 2
                }}
              >
                <Avatar
                  variant="rounded"
                  src={URL.createObjectURL(file)}
                  alt={file.name}
                  sx={{ 
                    width: 80, 
                    height: 80,
                    border: '1px solid',
                    borderColor: 'divider'
                  }}
                />
                <Box sx={{ flexGrow: 1 }}>
                  <Typography variant="body1" noWrap sx={{ fontWeight: 500 }}>
                    {file.name}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    {(file.size / 1024).toFixed(2)} KB
                  </Typography>
                </Box>
                <Chip 
                  label="Ready to upload" 
                  color="primary" 
                  size="small"
                  variant="outlined"
                />
                <IconButton 
                  onClick={() => handleRemoveImage(index)}
                  size="small"
                  sx={{ color: 'error.main' }}
                >
                  <Delete />
                </IconButton>
              </Paper>
            ))}
          </Stack>
        </Box>
      )}

      {/* Action Buttons */}
      <Stack direction="row" spacing={2} sx={{ mt: 3 }}>
        <GradientButton 
        text={uploadStatus === 'uploading' ? 'Uploading...' : `Upload ${selectedFiles.length} Image${selectedFiles.length > 1 ? 's' : ''}`}
        onClick={handleUpload}
        width={{lg:"30%",xs:"100%",md:"60%",}}/>
        
        {selectedFiles.length > 0 && (
          <SecondaryButton text="Clear All"
           onClick={() => setSelectedFiles([])}
              disabled={uploadStatus === 'uploading'}
              width="40%"/>
         
        )}
      </Stack>
     </Box>
    </Paper>
  );
};
export default YourApartmentPlotAddImages;